import React, {Component} from 'react';
import {Link, withRouter} from 'react-router-dom';
import {translate} from 'react-i18next';
import PropTypes from 'prop-types';
import CounterView from '../Counter/CounterView';
import PickUpTimeLayout from '../../containers/PickUpTime';
import RestaurantLayout from '../../containers/Restaurant';
import {
  getCartDealDetails,
  getFormatPrice,
  getPizzaExtraIngredients,
  getProductOption,
} from '../../helpers';
import moment from 'moment/moment';
import momentDuration from 'moment-duration-format';
import ReactDOM from "react-dom";

class ProductCartView extends Component {
  constructor(props) {
    super(props);

    momentDuration(moment);
    this.timeLeftRef = React.createRef();
  }

  isType(item, type) {
    return item.typeProduct === type;
  }

  canCustomize(item) {
    return (this.isType(item, 'pizza') && !item.product.is_special_pizza) || this.isType(item, 'deals');
  }

  componentDidUpdate(prevProps) {
    if (this.props.timeLeft < 0) {
      const formNode = ReactDOM.findDOMNode(this.timeLeftRef.current);
      if (formNode) {
        formNode.scrollIntoView(true);
      }
    }
  }

  render() {
    const {
      restaurant, basketList, totalCost, onRemove, language, t, closeBasket,
      ingredients, validateOrder, clearBasket, increase, decrease, onTimeChange, timeLeft,
    } = this.props;
    return (
        <div className="cart">
          <div className="cart__panel">
            <div className="cart__title">
              {t('voteCart')}
              <button className="cart__title-btn" onClick={closeBasket}>
              </button>
            </div>
            {!!basketList.length &&
            <div className="cart__row">
              <div
                className="cart__select"
                ref={this.timeLeftRef}
              >
                <RestaurantLayout/>
                <div className="cart__select-note cart__select-note--marked">
                  {t('takeAway')}
                </div>
              </div>
              <PickUpTimeLayout
                classNames='cart__select'
                onChangeTime={onTimeChange}
              />
              {timeLeft >= 0 ?
                <div className="cart__select-note">
                  {t('take_time_pizza', {minute: moment.duration(timeLeft, 'seconds').format('hh[h] mm[m] ss[s]')})}
                </div>
                :
                <div className="cart__errors">
                  {t('please_choose_time')}
                </div>
              }
            </div>
            }
            {!!basketList.length &&
            <div className="cart__row cart__row--has-scroller">
              <div className="cart__scroller">
                {basketList.map((obj, index) => (
                    <div
                        className="cart-item"
                        key={(obj.product.category ? obj.product.category.name : 'pizza') + '-' +
                        obj.productId + '-' + index}
                    >
                      <div className="cart-item__info">
                        <div className="cart-item__left">
                          <div className="cart-item__title">{obj.product[`name_${language}`]}</div>
                          {obj.crustID && obj.crustName && obj.typeProduct === 'pizza' &&
                          <div className="cart-item__details">{obj.crustName}
                            {!obj.product.is_special_pizza &&
                              <React.Fragment>
                                <span className='divider'>|</span>
                                {t(obj.size)}
                              </React.Fragment>
                            }
                            </div>
                          }
                          {this.isType(obj, 'pizza') &&
                          <div className="cart-item__details">
                            {getPizzaExtraIngredients(obj, ingredients, language)
                                .map((ingredient, dataIndex) => (
                                    <div
                                        key={dataIndex}>{ingredient.sign} {ingredient.name} x {ingredient.amount}</div>
                                ))}
                          </div>
                          }
                          {this.isType(obj, 'product') && <div
                              className="cart-item__details">
                            {getProductOption(obj, language).map((option, optionIndex) => (
                                <span
                                    key={optionIndex}
                                >{option}{getProductOption(obj, language).length > 1 &&
                                optionIndex < getProductOption(obj, language).length - 1 &&
                                ' | '}</span>
                            ))}
                        </div>
                        }
                        {this.isType(obj, 'deals') &&
                          <div className="cart-item__details">
                          {getCartDealDetails(restaurant, obj, language)
                            .map((data, dataIndex) => (
                              <div key={dataIndex}>{t('cart_deal_detail', data)}</div>
                            ))}
                        </div>}
                      </div>
                      <div className="cart-item__right">
                        <div className="cart-item__price">{getFormatPrice(obj.cost)}€</div>
                        <Link
                          to='#'
                          onClick={() => onRemove(obj.typeProduct, index)}
                          className="cart-item__remove">{t('removeFromBasket')}
                        </Link>
                      </div>
                    </div>
                    <div className="cart-item__counter">
                      <CounterView
                        increase={() => increase(obj)}
                        decrease={() => decrease(obj)}
                        value={obj.quantity}
                      />
                      {this.canCustomize(obj) &&
                      <Link
                        to={{
                          pathname: `/${language}/${restaurant.name_for_url}/products/${obj.typeProduct}/customize/${obj.productId}`,
                          state: {
                            ...obj,
                            action: 'update',
                          },
                        }}
                        className="cart-item__link">{t('customize')}</Link>
                      }
                    </div>
                  </div>
                ))}
              </div>
            </div>
            }
            {!!basketList.length &&
            <div className="cart__row cart__row--delete">
              <Link to="#" onClick={clearBasket}>{t('clear_all')}</Link>
            </div>
            }
            {!basketList.length &&
            <div className="cart__row">
              {t('emptyBasket')}
            </div>
            }
            {/*<div className="cart__row">*/}
              {/*<small>{t('promo')}</small>*/}
            {/*</div>*/}
            <div className="cart__total">
              {t('totalCost')}: <span className="cart__price">
            {getFormatPrice(totalCost)}€ {!!basketList.length && 'TTC'}
            </span>
            </div>
          </div>
          <button
            className="cart__button"
            disabled={!basketList.length || timeLeft < 0}
            onClick={validateOrder}
          >
            {t('valider')}
          </button>
          <button className="cart__button cart__button--close" onClick={closeBasket}>
          </button>
        </div>
    );
  }
}

ProductCartView.propTypes = {
  restaurant: PropTypes.object,
  basketList: PropTypes.array,
  totalCost: PropTypes.number,
  onRemove: PropTypes.func,
  increase: PropTypes.func,
  decrease: PropTypes.func,
  language: PropTypes.string,
  closeBasket: PropTypes.func,
  clearBasket: PropTypes.func,
  validateOrder: PropTypes.func,
  ingredients: PropTypes.array,
  onTimeChange: PropTypes.func,
  timeLeft: PropTypes.number,
};

export default withRouter(translate('translations')(ProductCartView));


// WEBPACK FOOTER //
// ./src/components/Product/ProductCartView.js